import { OrderByDirection, getCountFromServer, getDocs } from "firebase/firestore";
import { WithdrawalRequest } from "../types/withdrawal-request.entity";
import { Repository } from "src/firebase/firestore/repository";
import { buildFilterQuery } from "src/firebase/firestore/filterQueryBuilderV3";

export class WithdrawalRequestRepository extends Repository<WithdrawalRequest> {
  constructor() {
    super("withdrawal_requests");
  }

  async count(where?: any): Promise<number> {
    const filterQuery = await buildFilterQuery({
      collection: this.collection,
      where,
    });
    const countResult = await getCountFromServer(filterQuery);
    return countResult.data().count;
  }
}
export const withdrawalRequestRepository = new WithdrawalRequestRepository();
